import React, { Component } from "react";

class Colonoscopy extends Component {
    render() {
      return (
        <>
            <h2 className="uppertitle">What is a Colonoscopy?</h2>
<section className="upperexplanation">
    <p>
        Colonoscopy (koh-luh-NAH-skuh-pee)
        lets the physician look inside your entire
        large intestine, from the lowest part, the
        rectum, all the way up through the colon
        to the lower end of the small intestine.
        The procedure is used to look for early
        signs of cancer in the colon and rectum.
        It is also used to diagnose the causes of
        unexplained changes in bowel habits.
        Colonoscopy enables the physician to see
        inflamed tissue, abnormal growths,
        ulcers, and bleeding.
    </p>
    <p>
        For the procedure, you will lie on your
        left side on the examining table. You will
        be given sedation to keep you comfortable
        and to help you relax during the exam.
        The physician will insert a long, flexible,
        lighted tube into your rectum and slowly
        guide it into your colon. The tube is
        called a colonoscope
        (koh-LON-oh-skope). The scope
        transmits an image of the inside of the
        colon, so the physician can carefully
        examine the lining of the colon. The
        scope bends, so the physician can move
        it around the curves of your colon. You
        may be asked to change position
        occasionally to help the physician move
        the scope. The scope also blows air into
        your colon, which inflates the colon and
        helps the physician see better.
    </p>
    <p>
        If anything abnormal is seen in your
        colon, like a polyp or inflamed tissue, the
        physician can remove all or part of it using tiny instruments passed through the scope. That
        tissue (biopsy) is then sent to a lab for testing. If there is bleeding in the colon, the
        physician can pass a laser, heater probe, or electrical probe, or inject special medicines
        through the scope and use it to stop the bleeding.
    </p>
    <p>
        Bleeding and puncture of the colon are possible complications of colonoscopy. However,
        such complications are uncommon.
    </p>
    <p>
        Colonoscopy takes 30 to 60 minutes. The sedative should keep you
        from feeling discomfort during the exam. You will need to remain at the endoscopy
        facility for 30 minutes to 1 hour until the sedative wears off.
    </p>
    <h3>Preparation</h3>
    <p>
        Your colon must be completely empty for the colonoscopy to be thorough and safe. To
        prepare for the procedure you may have to follow a liquid diet for 1 to 3 days beforehand.
        A liquid diet means fat-free bouillon or broth, strained fruit juice, water, plain coffee, plain
        tea, or diet soda. Gelatin or popsicles in any color but red may also be eaten. You will also
        take one of several types of laxatives the night before the procedure. Also, you must
        arrange for someone to take you home afterward--you will not be allowed to drive because
        of the sedatives. Your physician may give you other special instructions. Inform your
        physician of any medical conditions or medications that you take before the colonscopy.
    </p>
</section>
        </>
      );
    }
  }
   
  export default Colonoscopy;